import i18next from 'i18next';

i18next.addResources('es_CL', 'RejectedOrdersFilters', {
  pickUp: 'Retiro',
  delivery: 'Delivery',
  oneHour: 'Hace 1 hora',
  fourHours: 'Hace 4 horas',
  twelveHours: 'Hace 12 horas',
  twentyFourHours: 'Hace 24 horas',
  anyHour: 'Cualquier hora',
  stores: 'Tiendas',
  dispatchMethods: 'Mètodos de despacho',
  orderAge: 'Horas',
  orderId: 'Id de la orden',
  filter: 'Filtrar'
});

i18next.addResources('es_CR', 'RejectedOrdersFilters', {
  pickUp: 'Retiro',
  delivery: 'Delivery',
  oneHour: 'Hace 1 hora',
  fourHours: 'Hace 4 horas',
  twelveHours: 'Hace 12 horas',
  twentyFourHours: 'Hace 24 horas',
  anyHour: 'Cualquier hora',
  stores: 'Tiendas',
  dispatchMethods: 'Mètodos de despacho',
  orderAge: 'Horas',
  orderId: 'Id de la orden',
  filter: 'Filtrar'
});
